// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer[data-v-6e04ae3a] {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/PublicationHeader.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".cursor-pointer[data-v-6e04ae3a] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
